import React from 'react';
import { CustomPlaceholderStyled } from './styled';
export function CustomPlaceholder({ title }) {
    return React.createElement(CustomPlaceholderStyled, null, title);
}
